require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./laptops-posidon-1-10-4.json") })
        }
      }, "path---laptops-posidon-1-10-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---laptops-posidon-1-10-4!./.cache/json/laptops-posidon-1-10-4.json
// module id = 474
// module chunks = 231608221292675